import { Injectable, isDevMode } from '@angular/core';
import { StaffsHelpbuttonDaoService } from 'src/app/dao/helpbutton-dao-services/staffs-helpbutton-dao-service/staffs-helpbutton-dao.service';
import { EMPTY, Observable, Subject } from 'rxjs';
import { StaffBasic } from 'src/app/models/helpbutton-models/helpbutton-staff-basic.model';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { UserService } from '../../user-service/user.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class StaffsHelpbuttonService {

  accessToken = 'HEL';
  refreshStaffsListener = new Subject<any>();
  refreshStaffListener = new Subject<any>();
  filterStaffsListener = new Subject<any>();
  searchStaffsListener = new Subject<any>();
  toggleStaffsDispositionListener = new Subject<any>();

  constructor(private staffsDaoService: StaffsHelpbuttonDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getStaffs() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.getStaffs(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const staffs = new Array<StaffBasic>();
          o['data']['staffList'].forEach(
            (item) => {
              const staff = new StaffBasic();
              Object.assign(staff, item);
              staffs.push(staff);
            }
          );
          return staffs;
        })
      );
    }
    return EMPTY;
  }

  public getStaffsCounts() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.getStaffsCounts(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          return {
            availableStaffs: o['data']['counters']['nbAvailables'],
            unavailableStaffs: o['data']['counters']['nbDisabled']
          };
        })
      );
    }
    return EMPTY;
  }

  public getStaffInfo(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.getStaffInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public addNewStaff(userImage, active, email, firstname, lastname, password, centerInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.addNewStaff(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), userImage, active, email, firstname, lastname, password, centerInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateStaff(internalId, userImage, active, email, firstname, lastname, centerInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.updateStaff(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, userImage, active, email, firstname, lastname, centerInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public deleteStaff(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.deleteStaff(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }
  public updateImageStaff(internalId, imageRaw) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.staffsDaoService.updateImageStaff(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, imageRaw).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }
  public refreshStaffs() {
    this.refreshStaffsListener.next();
  }

  public refreshStaffsListen() {
    return this.refreshStaffsListener.asObservable();
  }

  public refreshStaff() {
    this.refreshStaffListener.next();
  }

  public refreshStaffListen() {
    return this.refreshStaffListener.asObservable();
  }
  public searchStaffs(filterKey) {
    this.searchStaffsListener.next(filterKey);
  }
  public searchStaffsListen() {
    return this.searchStaffsListener.asObservable();
  }
  public filterStaffs(opts) {
    this.filterStaffsListener.next(opts);
  }
  public filterStaffsListen() {
    return this.filterStaffsListener.asObservable();
  }
  public toggleStaffsDisposition(viewDis) {
    this.toggleStaffsDispositionListener.next(viewDis);
  }
  public toggleStaffsDispositionListen() {
    return this.toggleStaffsDispositionListener.asObservable();
  }

}
